import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
    Form, Input, FormFeedback, Label, Modal, ModalHeader, ModalBody,
} from "reactstrap";


//redux
import { useSelector, useDispatch } from "react-redux";
import withRouter from "components/_Common/withRouter";
import toastr from "toastr";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { addSchorVertical, editSchorVertical } from "store/actions";
import { withTranslation } from "react-i18next";


const AddEditModal = props => {
    const { modal, toggle, isEdit, itemData, fetchSchorVerticalListData } = props
    const [schorVerticalData, setSchorVerticalData] = useState();
    const { error, success, loading,editLoading } = useSelector(state => ({
        loading: state.SchorVertical.loading,
        error: state.SchorVertical.error,
        success: state.SchorVertical.success,
        editLoading:state.SchorVertical.editLoading,
    }));
    const dispatch = useDispatch();

    useEffect(() => {
        setSchorVerticalData(itemData)
    }, [itemData]);

    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            vertical: schorVerticalData?.vertical || '',
            is_active: schorVerticalData?.is_active || 'Y'
        },
        validationSchema: Yup.object({
            vertical: Yup.string().required(props.t("Please Enter Schor Concept")),
            is_active: Yup.string().required(props.t("Please Enter Schor Concept Status")),
        }),
        onSubmit: (values, { resetForm }) => {
            if (isEdit) {
                dispatch(editSchorVertical(values, schorVerticalData?.id, (res) => {
                    if (res.status === 'success') {
                        toastr.success(res.message)
                        
                        resetForm({
                            vertical: '',
                            is_active: ''
                        });
                        fetchSchorVerticalListData()
                        toggle()

                    } else {
                        toastr.error(res.message)
                        toggle()
                        

                    }
                }));
            } else {
                dispatch(addSchorVertical(values, props?.router?.navigate, (res) => {
                    if (res?.status === 'success') {
                        toastr.success(res.message)
                        
                        resetForm({
                            vertical: '',
                            is_active: ''
                        });
                        fetchSchorVerticalListData()
                        toggle()
                    } else {
                        toastr.error(res.message)
                        toggle()
                        
                    }
                }));
            }

        }
    });



    return (
        <React.Fragment>
            <Modal isOpen={modal} toggle={
                () => {
                    toggle()
                    
                }}>
                <ModalHeader tag="h4" toggle={
                    () => {
                        toggle()
                        
                    }}>
                    {!!isEdit ? props.t("Edit Vertical Schor") : props.t("Add Vertical Schor")}
                </ModalHeader>
                <ModalBody>
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                        }}
                    >

                        <div className="mb-3 d-block">
                            <Label className="form-label m-0 pb-1">{props.t("Concept")}:</Label>
                            <Input
                                name="vertical"
                                className="form-control"
                                placeholder={props.t("Enter Concept")}
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.vertical || ""}
                                invalid={
                                    validation.touched.vertical && validation.errors.vertical ? true : false
                                }
                            />
                            {validation.touched.vertical && validation.errors.vertical ? (
                                <FormFeedback type="invalid">{validation.errors.vertical}</FormFeedback>
                            ) : null}
                        </div>

                        {/* <div className="mb-3 d-flex align-items-center gap-3">
                            <Label className="form-label m-0">{props.t("Status")}:</Label>
                            <div className="d-flex align-items-center gap-2">
                                <Input
                                    id="yes"
                                    name="is_active"
                                    type="radio"
                                    checked={validation.values.is_active == 'Y' ? true : false}
                                    value="Y"
                                    onClick={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={
                                        validation.touched.is_active && validation.errors.is_active ? true : false
                                    }
                                />
                                <Label for="yes" className="form-label m-0">{props.t("Active")}</Label>
                                <Input
                                    id="no"
                                    name="is_active"
                                    checked={validation.values.is_active === 'N' ? true : false}
                                    value="N"
                                    type="radio"
                                    onClick={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={
                                        validation.touched.is_active && validation.errors.is_active ? true : false
                                    }
                                />
                                <Label for="no" className="form-label m-0">{props.t("In-Active")}</Label>

                            </div>
                            {validation.touched.is_active && validation.errors.is_active ? (
                                <FormFeedback type="invalid">{validation.errors.is_active}</FormFeedback>
                            ) : null}
                        </div> */}

                        {
                            editLoading ?
                                <div className="btn-login-admin mt-3 batches-add-modal-btn">

                                    <button
                                        type="button"
                                        className="btn btn-primary btn-block"
                                        disabled
                                        style={{width:'103px'}}
                                    >
                                        <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                        {props.t("Submit")}

                                    </button>
                                </div>
                                :
                                <div className="btn-login-admin mt-3 batches-add-modal-btn">
                                    <button
                                        className="btn btn-primary btn-block"
                                        type="submit"
                                    // disabled
                                    >
                                        {props.t("Submit")}

                                    </button>
                                </div>
                        }
                    </Form>
                </ModalBody>
            </Modal>

        </React.Fragment>
    );
};


AddEditModal.propTypes = {
    history: PropTypes.object,
    t: PropTypes.any,

};
export default withTranslation()(AddEditModal);
